import { render } from "./InfractionAnalysisForm.vue?vue&type=template&id=c8825a7c&scoped=true"
import script from "./InfractionAnalysisForm.vue?vue&type=script&lang=js"
export * from "./InfractionAnalysisForm.vue?vue&type=script&lang=js"

import "./InfractionAnalysisForm.vue?vue&type=style&index=0&id=c8825a7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8825a7c"]])

export default __exports__